import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AuthGuard } from "@royalty/service/auth";

const routes: Routes = [
	{
		path: "",
		loadChildren: "./components/pos#PoSModule",
		// component: HomeComponent,
		// pathMatch: 'full',
		// data: {
		// 	hideHeader: true,
		// 	hideFooter: true
		// }
	},
	// { path: 'authentication', loadChildren: './components/authentication#AuthenticationModule' },
	{ path: "pos", loadChildren: "./components/pos#PoSModule" },
	{
		path: "admin",
		loadChildren: "./components/admin#AdminModule",
		canActivateChild: [AuthGuard]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			preloadingStrategy: PreloadAllModules
		})
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
